import { AutogenModelCarrierDriverMessage, AutogenRowCarrierDriverMessage } from "./autogen/AutogenModelCarrierDriverMessage";

export class ModelCarrierDriverMessage extends AutogenModelCarrierDriverMessage<RowCarrierDriverMessage> {
    constructor() {
        super(RowCarrierDriverMessage);
    }
}

export class RowCarrierDriverMessage extends AutogenRowCarrierDriverMessage {
}